import React, { useState } from "react";

export const Navigation = (props) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);
  const toggleMenu = () => setMenuOpen((prev) => !prev);

  return (
    <>
      {/* Marquee ABOVE navbar */}
      <div className="offer-marquee">
        <div className="marquee-track">
          <span>⚡ Crompton Wave Plus Table Fan — <strong>₹2,450 மட்டும்!</strong></span>
          <span>🔥 Orient Desk 25 Fan — <strong>5 நாள் சலுகை ₹2,450!</strong></span>
          <span>💨 Lakshmi Aeromax Tower Fan — <strong>50% OFF ₹2,299!</strong></span>
          <span>✂️ HTC Clipper AT-118 — <strong>₹400 மட்டும்!</strong></span>
          <span>✂️ HTC Trimmer AT-539 — <strong>₹630 மட்டும்!</strong></span>
          <span>📺 TV Remote Combo — <strong>₹95 மட்டும்!</strong></span>
          <span>🔒 Bike Lock — <strong>₹100 மட்டும்!</strong></span>
          <span>🔌 Aro-Flex Wire Coil — <strong>₹1,350 மட்டும்!</strong></span>
          <span>⚡ Crompton Wave Plus Table Fan — <strong>₹2,450 மட்டும்!</strong></span>
          <span>🔥 Orient Desk 25 Fan — <strong>5 நாள் சலுகை ₹2,450!</strong></span>
          <span>💨 Lakshmi Aeromax Tower Fan — <strong>50% OFF ₹2,299!</strong></span>
          <span>✂️ HTC Clipper AT-118 — <strong>₹400 மட்டும்!</strong></span>
          <span>✂️ HTC Trimmer AT-539 — <strong>₹630 மட்டும்!</strong></span>
          <span>📺 TV Remote Combo — <strong>₹95 மட்டும்!</strong></span>
          <span>🔒 Bike Lock — <strong>₹100 மட்டும்!</strong></span>
          <span>🔌 Aro-Flex Wire Coil — <strong>₹1,350 மட்டும்!</strong></span>
        </div>
      </div>

      {/* Navbar */}
      <nav id="menu" className="navbar navbar-default navbar-fixed-top">
        <div className="container">
<div className="navbar-header">
            <div className="navbar-header-right">
              <span className="navbar-location">பேரையூர்</span>
              <button
                type="button"
                className={`navbar-toggle ${menuOpen ? "" : "collapsed"}`}
                onClick={toggleMenu}
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            </div>

            <a className="navbar-brand page-scroll" href="#page-top" onClick={closeMenu}>
              <img
                src="/img/logo.png"
                alt="Gurunathan Electronics"
                className="navbar-logo"
              />
              GURUNATHAN ELECTRONICS
            </a>
          </div>

          <div
            className={`collapse navbar-collapse ${menuOpen ? "in" : ""}`}
            id="bs-example-navbar-collapse-1"
          >
            <ul className="nav navbar-nav navbar-right">
              <li>
                <a href="#header" className="page-scroll" onClick={closeMenu}>Home</a>
              </li>
              <li>
                <a href="#about" className="page-scroll" onClick={closeMenu}>About</a>
              </li>
              <li>
                <a href="#services" className="page-scroll" onClick={closeMenu}>Services</a>
              </li>
              <li>
                <a href="#products" className="page-scroll" onClick={closeMenu}>Products</a>
              </li>
              <li>
                <a href="#gallery" className="page-scroll" onClick={closeMenu}>Gallery</a>
              </li>
              <li>
                <a href="#contact" className="page-scroll" onClick={closeMenu}>Contact</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};